import { request } from '@/shared/api/request'

export const getEquipmentData = ({data, params, payload: {type}}) => {
	return request({ url: `/assessment/dict/${type}`, method: 'GET', data: data, params: params })
}

export const getDownloadData = (payload) => {
	return request({ url: '/assessment/dict/download', method: 'GET', params:  payload, responseType: 'blob'})
}

export const getInssuanceNorm = (params) => {
	return request({ url: '/assessment/dict/inssuanceNorm', method: 'GET' })
}

export const getTemplate = (payload) => {
	return request({ url: '/assessment/dict/template', method: 'GET', params:  payload, responseType: 'blob'})
}